import React from 'react';
import ObsLogoWrapper from './ObsLogoWrapper';
import type { CompetitorType } from '../../types';

interface CompetitorLogoProps {
	competitor: CompetitorType;
	size?: number;
}

const competitorComponents: Record<
	CompetitorType,
	React.FC<{ size?: number }>
> = {
	obs: ObsLogoWrapper,
};

export const CompetitorLogo: React.FC<CompetitorLogoProps> = ({
	competitor,
	size,
}) => {
	const LogoComponent = competitorComponents[competitor];

	if (!LogoComponent) {
		return null;
	}

	return <LogoComponent size={size} />;
};

export { ObsLogoWrapper };
